import { gql } from 'react-apollo';

export default gql`
  mutation submitInvestment($input: InvestmentInput!) {
    submitInvestment(input: $input) {
      _id
      offerId
      paymentMethod
      paymentType
      investmentStatus
      subscriptionAgreementStatus
      brokerageAgreementStatus
      agreementEnvelopeId
      brokerageAgreementEnvelopeId
      paymentSent
      investmentAmount
      networth
      question_one
      question_two
      question_three
      question_four
      question_five
      question_six
      question_seven
      question_eight
      question_nine
      question_ten
      income
      investmentAmountCrypto
      walletAddress
      transactionId
      receiptImageId
      receiptImageUrl
      sharesOrTokensPurchased
      investmentReviewAgreement
      closingDateAgreement
      crowdfundingQuestion
      crowdfundingAmount
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/submitInvestment.js